/** Title-case enum labels for display (API values stay lowercase). */
export function titleCaseLabel(value: string | null | undefined): string {
  if (!value) return '';
  return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
}
